import React, { useState } from "react";
import {
  Button,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Spinner,
  Box,
  Text,
  FormControl,
} from "@chakra-ui/react";
import { LockIcon, ViewIcon, ViewOffIcon } from "@chakra-ui/icons";

const ForgotPasswordStep2 = (props) => {
  const { confirmPasswordHandler, isLoading, errorText } = props;
  const [verificationCode, setVerificationCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const handleShowPwd = () => setShowPwd(!showPwd);

  return (
    <Box>
      <Text fontSize="xl" mt={6} mb={2}>
        Enter verification code and new password
      </Text>
      <form onSubmit={confirmPasswordHandler}>
        <FormControl>
          <Input
            mt={2}
            mb={2}
            type="text"
            placeholder="Enter Verification Code"
            value={verificationCode}
            name="verificationCode"
            onChange={(event) => setVerificationCode(event.target.value)}
          />
        </FormControl>

        <FormControl>
          <InputGroup mt={2} mb={2}>
            <InputLeftElement
              pointerEvents="none"
              children={<LockIcon />}
              color="gray"
            />

            <Input
              type={showPwd ? "text" : "password"}
              placeholder="Enter New Password"
              value={newPassword}
              name="newPassword"
              onChange={(event) => setNewPassword(event.target.value)}
            />
            <InputRightElement
              children={
                showPwd ? (
                  <ViewIcon color="gray" onClick={handleShowPwd} />
                ) : (
                  <ViewOffIcon color="gray" onClick={handleShowPwd} />
                )
              }
            />
          </InputGroup>
        </FormControl>
        <Button
          mt={2}
          mb={2}
          type="submit"
          size="sm"
          colorScheme="blue"
          disabled={isLoading || !verificationCode || !newPassword}
        >
          {isLoading ? <Spinner size="sm" mr={2} /> : null}
          Submit
        </Button>
        <Text fontSize="xs" color="red">
          {errorText}
        </Text>
      </form>
    </Box>
  );
};

export default ForgotPasswordStep2;
